import type { SVGProps } from 'react';

const SvgLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="m12.28 16.28-.66.66c-.24.23-2.38 2.21-4.58 0-2.2-2.2-.23-4.35 0-4.58l.67-.67a.996.996 0 1 0-1.41-1.41l-.67.67c-1.28 1.28-2.93 4.48 0 7.4 1.2 1.2 2.45 1.63 3.6 1.63 1.64 0 3.05-.88 3.81-1.63l.67-.67a.996.996 0 1 0-1.41-1.41zm6.07-10.66c-2.93-2.93-6.12-1.28-7.4 0l-.67.67a.996.996 0 1 0 1.41 1.41l.66-.66c.24-.23 2.38-2.21 4.58 0s.23 4.35 0 4.58l-.67.67a.996.996 0 0 0 0 1.41c.19.2.45.29.71.29s.51-.1.71-.29l.67-.67c1.28-1.28 2.93-4.48 0-7.4z"
    />
    <path
      fill="currentcolor"
      d="m13.28 9.29-3.99 3.99a.996.996 0 0 0 .71 1.7c.26 0 .51-.1.71-.29l3.99-3.99a.996.996 0 1 0-1.41-1.41z"
    />
  </svg>
);
export default SvgLink;
